import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import api from "../api/api";
import MagmaSelect from "../components/MagmaSelect";
import "./PlanejamentoDetalhe.css";

export default function PlanejamentoCreatePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const initialWorkspaceId = location.state?.workspaceId ? String(location.state.workspaceId) : "";

  const [workspaces, setWorkspaces] = useState([]);
  const [workspaceId, setWorkspaceId] = useState(initialWorkspaceId);
  const [planejamentoNome, setPlanejamentoNome] = useState("");
  const [planejamentoDescricao, setPlanejamentoDescricao] = useState("");
  const [planejamentoStatusId, setPlanejamentoStatusId] = useState("1");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const workspaceName = useMemo(
    () => workspaces.find(item => String(item.id) === String(workspaceId))?.nome || "Nao identificado",
    [workspaces, workspaceId]
  );

  useEffect(() => {
    const loadWorkspaces = async () => {
      try {
        setLoading(true);
        setError("");
        const res = await api.get("/workspaces/");
        const list = res.data || [];
        setWorkspaces(list);
        if (!workspaceId && list.length > 0) {
          setWorkspaceId(String(list[0].id));
        }
      } catch (err) {
        setError(err?.response?.data?.detail || "Falha ao carregar workspaces.");
      } finally {
        setLoading(false);
      }
    };

    loadWorkspaces();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSavePlanejamento = async () => {
    if (!workspaceId) {
      setError("Selecione um workspace.");
      return;
    }
    if (!planejamentoNome.trim()) {
      setError("Nome do planejamento e obrigatorio.");
      return;
    }

    try {
      setLoading(true);
      setError("");
      const createRes = await api.post(`/planejamentos/workspaces/${workspaceId}`, {
        nome: planejamentoNome.trim(),
        descricao: planejamentoDescricao.trim() ? planejamentoDescricao.trim() : null,
      });

      const created = createRes.data;
      if (created?.id && Number(planejamentoStatusId) !== 1) {
        await api.put(`/planejamentos/${created.id}`, {
          status_id: Number(planejamentoStatusId),
        });
      }

      navigate("/planejamentos", {
        replace: true,
        state: { workspaceId: String(workspaceId) },
      });
    } catch (err) {
      setError(err?.response?.data?.detail || "Erro ao salvar dados do planejamento.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="plan-view-page">
      <header className="plan-view-header">
        <p className="plan-view-kicker">Planejamento</p>
        <h1 className="plan-view-title">Novo planejamento</h1>
        <p className="plan-view-subtitle">Workspace: {workspaceName}</p>
      </header>

      {loading ? <p>Carregando...</p> : null}
      {error ? <p className="plan-view-error">{error}</p> : null}

      <section className="plan-view-grid">
        <article className="plan-view-card plan-span-full">
          <h2>Dados do planejamento</h2>
          <div className="plan-inline-form">
            <label className="plan-label" htmlFor="planejamento-workspace">Workspace</label>
            <MagmaSelect
              id="planejamento-workspace"
              className="plan-select"
              value={workspaceId}
              onChange={e => setWorkspaceId(e.target.value)}
            >
              <option value="">Selecione workspace</option>
              {workspaces.map(item => (
                <option key={item.id} value={item.id}>{item.nome}</option>
              ))}
            </MagmaSelect>

            <label className="plan-label" htmlFor="planejamento-nome">Nome do planejamento</label>
            <input
              id="planejamento-nome"
              className="plan-input"
              value={planejamentoNome}
              onChange={e => setPlanejamentoNome(e.target.value)}
              placeholder="Nome do planejamento"
            />

            <label className="plan-label" htmlFor="planejamento-descricao">Descricao</label>
            <input
              id="planejamento-descricao"
              className="plan-input"
              value={planejamentoDescricao}
              onChange={e => setPlanejamentoDescricao(e.target.value)}
              placeholder="Descricao"
            />

            <label className="plan-label" htmlFor="planejamento-status">Status</label>
            <MagmaSelect
              id="planejamento-status"
              className="plan-select"
              value={planejamentoStatusId}
              onChange={e => setPlanejamentoStatusId(e.target.value)}
            >
              <option value="1">Rascunho</option>
              <option value="2">Em execucao</option>
              <option value="3">Finalizado</option>
            </MagmaSelect>

            <button className="plan-btn" type="button" onClick={handleSavePlanejamento} disabled={loading}>
              Salvar dados
            </button>
          </div>
        </article>
      </section>
    </main>
  );
}
